export const setStorageWithExpity = async (name, value, h = 2) => {
    const now = new Date()
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        // expiry: now.getTime() + (h * 60 * 60 * 1000),
    }
    localStorage.setItem(name, JSON.stringify(item))
}

export const getStorageWithExpiry = key => {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    // const now = new Date()
    // compare the expiry time of the item with the current time
    // if (now.getTime() > item.expiry) {
    //     // If the item is expired, delete the item from storage
    //     // and return null
    //     localStorage.removeItem(key)
    //     return null
    // }
    return item.value
}

export const rmStorage = async (name) => {
    localStorage.removeItem(name)
}

// *********** user login *********** 
export const setUserStorage = async (value) => {
    await setStorageWithExpity('user-login', value)
}

export const getUserStorage = () => {
    return getStorageWithExpiry('user-login')
    // localStorage.getItem('user-login')
}

export const rmUserStorage = async () => {
    localStorage.removeItem('user-login')
}
// *********** user login *********** 

// *********** home image *********** 
export const setHomeImageStorage = async (value) => {
    await setStorageWithExpity('home-image', value)
}

export const getHomeImageStorage = () => {
    return getStorageWithExpiry('home-image')
}

export const rmHomeImageStorage = async () => {
    localStorage.removeItem('home-image')
}
// *********** user login *********** 

// *********** user login *********** 
export const setThemeStorage = async (value) => {
    await setStorageWithExpity('rc-theme', value)
}

export const getThemeStorage = () => {
    return getStorageWithExpiry('rc-theme')
    // localStorage.getItem('user-login')
}

export const rmThemeStorage = async () => {
    localStorage.removeItem('rc-theme')
}
// *********** user login *********** 

// *********** job recommend ai *********** 
export const setJobRecommendAIStorage = async (value) => {
    await setStorageWithExpity('rc-job-recommend-ai', value)
}

export const getJobRecommendAIStorage = () => {
    return getStorageWithExpiry('rc-job-recommend-ai')
    // localStorage.getItem('user-login')
}

export const rmJobRecommendAIStorage = async () => {
    localStorage.removeItem('rc-job-recommend-ai')
}
// *********** user login *********** 

export const clearAllStorage = () => {
    localStorage.clear()
}

export const setJobReqStorage = async (value) => {
    await setStorageWithExpity('rc-job-req', value)
}

export const getJobReqStorage = async () => {
    return getStorageWithExpiry('rc-job-req')
}

export const rmJobReqStorage = async () => {
    localStorage.removeItem('rc-job-req')
}

export const setSearchHistoryStorage = async (value) => {
    await setStorageWithExpity(`search_history`, value)
}

export const getSearchHistoryStorage = () => {
    return getStorageWithExpiry(`search_history`)
}

export const rmSearchHistoryStorage = async () => {
     localStorage.removeItem(`search_history`)
}
